export const environment = {
  production: false,
  baseUrl: 'https://localhost:44385/api/',
  lightspeedRedirectUri: 'https://lightspeed.leisuretrends.com',
  envName: 'development',
};
